"use client";

import { useEffect, useState } from "react";

import classNames from "@calcom/ui/classNames";

export function Logo({
  small,
  icon,
  inline = true,
  className,
  src,
}: {
  small?: boolean;
  icon?: boolean;
  inline?: boolean;
  className?: string;
  src?: string;
}) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  if (!mounted) {
    return (
      <h3 className={classNames("logo", inline && "inline", className)}>
        <strong>
          <span className={classNames(small ? "h-8" : "h-12", "inline-block")} />
        </strong>
      </h3>
    );
  }

  return (
    <h3 className={classNames("logo", inline && "inline", className)}>
      <strong>
        {icon ? (
          <img className="mx-auto w-20" alt="Schedly" title="Schedly" src={src || "/api/logo?type=icon"} />
        ) : (
          <>
            <img
              className={classNames(small ? "h-7 w-auto" : "h-9 w-auto", "dark:hidden")}
              alt="Schedly"
              title="Schedly"
              src={src || "/schedly-logo-light.svg"}
            />
            <img
              className={classNames(small ? "h-7 w-auto" : "h-9 w-auto", "hidden dark:block")}
              alt="Schedly"
              title="Schedly"
              src={src || "/schedly-logo-dark.png"}
            />
          </>
        )}
      </strong>
    </h3>
  );
}
